import { SelectCombobox } from 'components/combobox';
import { useTranslation } from 'react-i18next';
import { PointMessageDto, usePointsQuery } from 'types/generated/graphql';

interface PointAutocompleteProps {
  selectedPointId: string;
  onChange: (point: PointMessageDto | null) => void;
  label?: string;
  required?: boolean;
}

/**
 * Reusable Point autocomplete component using SelectCombobox
 * Allows searching by Point ID, name, IP address, or GUID
 */
export function PointAutocomplete({
  selectedPointId,
  onChange,
  label,
  required,
}: PointAutocompleteProps) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('Events.Filter.Point');
  const { data } = usePointsQuery();
  const points =
    data?.points?.filter((point): point is PointMessageDto => !!point) ?? [];

  const selectedPoint = points.find((p) => p.id === selectedPointId) ?? null;

  return (
    <SelectCombobox
      items={points}
      value={selectedPoint}
      onChange={onChange}
      getItemLabel={(point) =>
        point
          ? `${point.pointRegistrationNumber || point.id} - ${point.pointIdentifier ?? t('Unknown')}`
          : ''
      }
      getItemValue={(point) => point.id}
      label={resolvedLabel}
      searchPlaceholder={t('Events.Filter.SearchPoint')}
      emptyMessage={t('Events.Filter.NoPoints')}
      required={required}
    />
  );
}
